var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-kravicka", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row align-items-center h100vh" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-md-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-0 text-center text-xl-left"
              },
              [
                _c("span", { staticClass: "customLabel" }, [
                  _vm._v("Ahoj " + _vm._s(_vm.userName))
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "smallerHeading" }, [
                  _vm._v("Poskladaj čo najrýchlejšie obrázok s kravičkou ")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "pexesoDescription" }, [
                  _vm._v(
                    "Vyskúšaj si svoju šikovnosť v známej hre sliding puzzle. Na výber máš tri obtiažnosti a rôzne motívy obrázkov. Kravička na púšti? Alebo radšej tá vo vesmíre? Tak šup, ukáž čo vieš."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttonsWrap" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "btn --primary --large --startGame mb-2 mb-md-0",
                        attrs: {
                          to: {
                            name: "slider-settings",
                            params: {
                              kravicka_id: _vm.$route.params.kravicka_id
                            }
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "icon" }),
                        _vm._v("Spustiť hru\n                        ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "btn --secondary --trophy",
                        attrs: {
                          to: {
                            name: "slider-leaders",
                            params: {
                              kravicka_id: _vm.$route.params.kravicka_id
                            }
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "icon" }),
                        _vm._v("Tabuľka najlepších\n                        ")
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "endGame",
                    attrs: {
                      to: {
                        name: "kravicka",
                        params: { kravicka_id: _vm.$route.params.kravicka_id }
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Ukončiť hru a vrátiť sa ku kravičke"
                    ),
                    _c("span", { staticClass: "icon" })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(0)
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pexesoFooter --right d-none d-md-flex" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn --primary closeGame",
              attrs: {
                to: {
                  name: "kravicka",
                  params: { kravicka_id: _vm.$route.params.kravicka_id }
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xl-6 d-none d-xl-block" }, [
      _c("img", { attrs: { src: "assets/img/puzzleMainImg.png", alt: "" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }